import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    components: {
    //      MuiTooltip: {
    //     styleOverrides: {
    //         popper: {
    //             zIndex: "1000000 !important",
    //         },
    //     },
    // },
        MuiToolbar: {
            styleOverrides: {
                gutters: {},
                root: {
                    display: 'flex',
                    justifyContent: 'space-between',
                }
            }
            
        },
        MuiBox: {
            styleOverrides: {
                root: {
                    background: "white"
                }
            }
            
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: "25px"
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                labelIcon: {
                    minHeight: "45px",
                    fontSize:"medium"
                   
                },
                root: {
                     "&.Mui-selected": {
                        color: "var(--primary-color)",
                        fontWeight: 'bold'
                        // borderRadius: "10px",
                   
                    },
                    
                }   
            }
        },

        MuiTabs: {
            styleOverrides: {
                indicator: {
                    // borderRadius: "10px",
                    // width: "50%",
                    height: "4px !important",
                    backgroundColor: 'var(--primary-color)'
                }
            }
        },

        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '20px 10px',
                }
            }
        },

        MuiCheckbox: {
            styleOverrides: {
                root: {
                    
                    checked: {
                        color: 'var(--primary-color) !important'
                    }
                }
            }
        },
        
        MuiTypography: {
            styleOverrides: {
                h6: {
                    color: "var(--primary-color)",
                    fontWeight: "bolder",
                    // marginBottom: "10px",
                    marginLeft: "10px"
                },
                root: {
                    fontFamily: 'Poppins',
                }

            }
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: 'white',
                    color: 'black',
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '98%'
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '24px'
                    // color: 'black'
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                standard: {
                    "&.Mui-disabled": {
                        cursor: "not-allowed",
                        background: 'light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))'
                    }
                }
            }
        },

        MuiInputBase: {
            styleOverrides: {
                input: {
                    padding:"5px",
                    "&.Mui-disabled":{
                         cursor: "not-allowed",
                        background: "light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))"
                    }
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    boxShadow: '2px 6px 5px 0px grey'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    paddingLeft: '16px !important',
                    minHeight: '35px !important',
                    padding: '4px 16px !important',
                    // "margin": "0px 13px",
                    "&.Mui-selected": {
                        "backgroundColor": "var(--primary-color)",
                        "color": "white",
                        "fontWeight": "bold",
                        // "margin": "0px 13px",
                        "borderRadius": "5px"
                    },
                    "&.Mui-selected:hover": {
                        "backgroundColor": "var(--primary-color)",
                        "color": "white",
                        "fontWeight": "bold",
                        "borderRadius": "5px"
                    },
                },
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: "#656565",
                    fontWeight: "bold",
                    // whiteSpace: "break-spaces"
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                   paddingLeft: 0
                },
                content: {
                    "&p": {
                        fontWeight: '800 !important'
                    }
                }
            }
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                   padding: "5px"
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderBottom: '1px solid darkgrey',
                    margin: '25px 0',
                    boxShadow: 'none'
                }
            }
        },
        MuiDataGrid: {
            columnHeadersInner: {
                color: 'white',
                backgroundColor: 'black',
            },
            styleOverrides: {
                columnHeaderTitle: {
                        fontWeight: 700
                    }
                }
    
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    padding: "0px !important"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    minWidth: 'unset !important'
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderColor: "red",
                    marginBottom: "10px"
                }
            }
        },
        // MuiDrawer: {
        //     styleOverrides: {
        //         docked: {
        //             "&.MuiDrawer-paper": {
        //                 width: "65px !important"
        //             }
        //         }
        //     }
        // },
        MuiButton: {
            styleOverrides: {
                root: {
                    border: 'unset !important'
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: '12.5px 16px',
                    borderRadius: '15px !important'
                },
                notchedOutline: {
                    borderColor: '#656565 !important'
                },
                root: {
                    borderRadius: '10px !important',
                    // marginBottom: '8px !important'
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'black'
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                content: {
                    margin: "0px"
                },
                expandIconWrapper: {
                    // color: "white"
                },
                root: {
                    // background: "lightslategrey",
                       border: "2px solid var(--primary-color) !important",
                    borderRadius: "10px",
                    "& .MuiTypography-root": {
                        color: "var(--primary-color)",
                    },

                    "& *": {
                        color: "var(--primary-color)",
                    },
               
                }
            }
        },
        
        MuiAccordion: {
            styleOverrides: {
                gutters: {
                    boxShadow: "unset"
                },
                root: {
                    margin: "0px",
                    boxShadow: "unset !important",
                    position: "unset"
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                MuiToolbar: {
                    MuiButton: {
                        root: {
                            border: "1px solid black"
                        }
                        
                    }
                },
                columnHeaderTitle: {
                    fontWeight: 700
                },
                columnHeaders: {
                    border: "1px solid #CECECE",
                },
                footerContainer: {
                    border: "1px solid #CECECE",
                    "& .MuiToolbar-root": {
                        minHeight: "auto",
                        paddingTop: 0,
                        paddingBottom: 0,
                        bottom: 0,
                    },
                },
                root: {
                    fontFamily: 'Poppins',
                    borderColor: '#CECECE !important',
                    borderBottom: "0px !important",
                    boxSizing: "border-box !important",
                },
            }
        },
        MuiTabPanel: {
            styleOverrides: {
                root: {
                    // borderRadius: "20px"
                    // backgroundColor: "transparent"
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    // height: "21px"
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
            popper: {
                color: 'red'
            }}
    }}
    
});


